import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactTable from "react-table";
import _ from 'lodash';
import ContainerDimensions from 'react-container-dimensions';
import { connect } from 'react-redux';
import ClipboardJS from 'clipboard';
import { maybeSerializedJson, getFields, dateSort, findBootstrapEnvironment, getAssignedToFullName, stripHtml } from '../../helpers/utils';
import Button from './Button';
import { Glyphicon, DropdownButton, MenuItem } from 'react-bootstrap';
import ReactTablePagination from './ReactTablePagination';
import { integerSort, floatSort } from './../../helpers/utils';
import ConfirmDialog from './ConfirmDialog';
import { fitToViewport } from '../../helpers/fitHeight';
import CheckBox from './CheckBox';
import { deletedRowColor } from '../../helpers/colors';


export const getSquareColorTdProps = (columnId, colorFunc) => {
    return (state, rowInfo, column, instance, props) => {
        let style = {};
        if (column.id === columnId) {
            const bgColor = colorFunc(rowInfo, props.currentConfig);
            style = {
                backgroundColor: bgColor,
                height: '20px',
                marginTop: '15px',
                marginBottom: '-15px',
            };
        } if (rowInfo && rowInfo.original['deleted_at']) {
            style = { backgroundColor: deletedRowColor };
        }

        return {
            onClick: (e, handleOriginal) => {
                if (!rowInfo) {
                    return;
                }

                if (column.id === 'check') {
                    return;
                }

                if (props.getTdProps && props.editRow) {
                    props.editRow(rowInfo.index, rowInfo.original);
                    return;
                }

                if (column.id === 'action') {
                    return;
                }

                if (props.editRow) {
                    props.editRow(rowInfo.index, rowInfo.original);
                } else if (props.selectRow) {
                    props.selectRow(rowInfo.index, rowInfo.original);
                } else if (props.downloadRow) {
                    props.downloadRow(rowInfo.index, rowInfo.original);
                }
            },
            style,
        };
    }
};


class CustomNoDataComponent extends PureComponent {
    render() {
        let result = <div/>;
        if (this.props.noDataText) {
            result = <div className="rt-noData">{this.props.noDataText}</div>;
        }

        return result;
    }
}

class TextDataCell extends PureComponent {
    constructor(props) {
        super(props);
        this.getDataForRow = this.getDataForRow.bind(this);
    }

    render() {
        const { value } = this.props;
        if (typeof(value) === "object") {
            return (<div style={{paddingTop: 7}}>ERROR: {JSON.stringify(value)}</div>);
        }

        return (
            <div style={{paddingTop: 7}}>{this.getDataForRow(value)}</div>
        );
    }

    getDataForRow(value) {
        let text = value;
        if (text === '{}') {
            return "";
        }

        if (maybeSerializedJson(text)) {
            try {
                let obj = JSON.parse(text);
                if (obj['$Label$']) {
                    text = obj['$Label$'];
                }

            } catch (e) {}
        } else if (_.isString(text) && text.startsWith('<div>')) {
            text = stripHtml(text);
        }

        return text;
    }
}

class ActionCell extends PureComponent {
    constructor(props) {
        super(props);
        this.selectRow = this.selectRow.bind(this);
        this.editRow = this.editRow.bind(this);
        this.archiveRow = this.archiveRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.downloadRow = this.downloadRow.bind(this);
    }

    editRow(evt) {
        evt.preventDefault();
        this.props.editRow(this.props.index,
                           this.props.row);
    }

    archiveRow(evt) {
        evt.preventDefault();
        this.props.archiveRow(this.props.index,
                              this.props.row);
    }

    deleteRow(evt) {
        evt.preventDefault();
        this.props.deleteRow(this.props.index,
                             this.props.row);
    }

    selectRow(evt) {
        evt.preventDefault();
        this.props.selectRow(this.props.index,
                             this.props.row);
    }

    downloadRow(evt) {
        evt.preventDefault();
        this.props.downloadRow(this.props.index,
                               this.props.row);
    }

    render() {
        let editButton = '';
        let archiveButton = '';
        if (this.props.archiveRow) {
            archiveButton = (
                <Button onClick={this.archiveRow}
                        icon="briefcase"/>
                );
        }

        let deleteButton = '';
        if (this.props.deleteRow) {
            deleteButton = (
                <Button onClick={this.deleteRow}
                        icon="trash"
                        label={this.props.deleteLabel}
                        bsStyle={this.props.deleteBsStyle}/>
                );
        }

        let selectButton = '';
        if (this.props.selectRow) {
            selectButton = (
                <Button onClick={this.selectRow}
                        icon="hand-up"
                        label={this.props.selectLabel}
                        bsStyle={this.props.selectBsStyle}/>
            );
        }

        let copyButton = '';
        if (this.props.copyRow) {
            const text = this.props.copyRow(this.props.row, this.props.index);
            copyButton = (
                <button data-clipboard-text={text}
                        className="copyBtn"
                >
                        <Glyphicon glyph="copy" />
                </button>
            );
        }

        let checkButton = '';
        if (this.props.checkRow) {
            // When the quick-action button sits next to the checkbox, drop the
            // negative bottom margin so the two are vertically centered.
            //
            const checkStyle = this.props.renderRowActions
                ? {paddingTop: 0, paddingBottom: 0, margin: 0, display: 'block'}
                : {paddingTop: 0, marginBottom: -10, paddingBottom: 0};
            checkButton = (
                <CheckBox
                    field={{
                        name: 'RowCheckBox' + this.props.index
                    }}
                    plainInput
                    checked={!!this.props.checkedRows && !!this.props.checkedRows[this.props.index]}
                    onChange={() => this.props.checkRow([this.props.row], [this.props.index])}
                    style={checkStyle}
                />
            );
        }

        let rowActions = '';
        if (this.props.renderRowActions) {
            rowActions = this.props.renderRowActions(this.props.row, this.props.index);
        }

        // Keep the checkbox and the quick-action button on a single row.
        //
        const layoutStyle = this.props.renderRowActions
            ? { display: 'flex', alignItems: 'center' }
            : undefined;

        return (
            <div style={layoutStyle}>
            {checkButton}
            {editButton}
            {rowActions}
            {archiveButton}
            {selectButton}
            {deleteButton}
            {copyButton}
            </div>
        );
    }
}

export class CustomTable extends PureComponent {
    constructor(props) {
        super(props);
        this.onColumnResized = this.onColumnResized.bind(this);
        this.onTableViewChange = this.onTableViewChange.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.fitHeight = this.fitHeight.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.visibleRows = [];
        this.tableRef = React.createRef();
        // visibleCount: rows rendered so far in client side tables; more are added while scrolling.
        this.state = { sorted: [], visibleCount: 50, bulkChecked: {}, bulkConfirmOpen: false };
        this.bulkCheckRow = this.bulkCheckRow.bind(this);
    }

    // Asc -> desc -> the third click on the same column goes back to the default order.
    nextSort(previous, sorted) {
        const cycled = sorted.length === 1 && previous && previous.length === 1 &&
            previous[0].id === sorted[0].id && previous[0].desc && !sorted[0].desc;
        return cycled ? [] : sorted;
    }

    fitHeight() {
        fitToViewport(this.tableRef.current);
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);
        window.addEventListener('resize', this.fitHeight);
        this.fitHeight();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.fitHeight);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.getRef) {
            nextProps.getRef(this.tableRef);
        }
    }

    // Tables whose widths are not stored in the user's settings (onColumnResized) remember them in this browser.
    resizedStorageKey() {
        const signature = (this.props.headers || []).map(h => `${h.table}.${h.name}`).join('|');
        let hash = 0;
        for (let i = 0; i < signature.length; i += 1) {
            hash = ((hash << 5) - hash + signature.charCodeAt(i)) | 0;
        }

        return `ct-colw:${hash}`;
    }

    loadResized() {
        if (this.props.onColumnResized) {
            return undefined;
        }

        try {
            const saved = JSON.parse(window.localStorage.getItem(this.resizedStorageKey()));
            return Array.isArray(saved) ? saved : undefined;
        } catch (e) {
            return undefined;
        }
    }

    onColumnResized(newResized, _evt) {
        if (!this.props.onColumnResized) {
            try {
                window.localStorage.setItem(this.resizedStorageKey(), JSON.stringify(newResized));
            } catch (e) {}

            return;
        }

        if (this.columnResizedTimeoutId) {
            try {
                clearTimeout(this.columnResizedTimeoutId);
                this.columnResizedTimeoutId = undefined;
            } catch (error) {
                console.error(new Error().stack, error);
            }
        }

        this.columnResizedTimeoutId = setTimeout(() => {
            this.columnResizedTimeoutId = undefined;
            let newHeaders = [...this.props.headers];
            for (let i = 0; i < newResized.length; i++) {
                let columnKey = newResized[i].id;
                if (_.isString(columnKey)) {
                    const name = columnKey.substr(columnKey.lastIndexOf('.') + 1);
                    columnKey = newHeaders.findIndex(h => h.name === name);
                    if (columnKey === -1) {
                        console.error('Invalid column key: ' + newResized[i].id);
                        continue;
                    }
                }
                newHeaders[columnKey].width = newResized[i].value;
            }
            this.props.onColumnResized(newHeaders);
        }, 1000);
    }

    // The server sorts by `table.name`; react-table identifies a column by its id (the header index).
    getSortAccessor(columnId) {
        const header = this.props.headers && this.props.headers[columnId];
        return header ? `${header.table}.${header.name}` : undefined;
    }

    // Infinite scroll for server paged tables: ask for the next page near the bottom.
    onScroll(e) {
        const { serverPaging, rows } = this.props;
        if (!rows) {
            return;
        }

        const el = e.currentTarget;
        if (!serverPaging) {
            if (this.state.visibleCount < rows.length && el.scrollTop + el.clientHeight >= el.scrollHeight - 240) {
                this.setState(({ visibleCount }) => ({ visibleCount: visibleCount + 50 }));
            }

            return;
        }

        const nearEnd = el.scrollTop + el.clientHeight >= el.scrollHeight - 240;
        const loaded = rows.length >= (serverPaging.page + 1) * serverPaging.pageSize;
        const more = serverPaging.page + 1 < serverPaging.pages;
        if (nearEnd && loaded && more && !this.props.loading) {
            serverPaging.onChange({ page: serverPaging.page + 1, append: true });
        }
    }

    // Bulk delete: a table that gets `deleteRows` shows a checkbox column and a "Delete selected" bar.
    effectiveCheckRow() {
        return this.props.checkRow || (this.props.deleteRows ? this.bulkCheckRow : undefined);
    }

    effectiveCheckedRows() {
        return this.props.checkRow ? this.props.checkedRows : this.state.bulkChecked;
    }

    bulkCheckRow(_rows, indexes) {
        if (indexes === undefined) {
            this.setState({ bulkChecked: {} });
            return;
        }

        const bulkChecked = { ...this.state.bulkChecked };
        indexes.forEach((index) => { bulkChecked[index] = !bulkChecked[index]; });
        this.setState({ bulkChecked });
    }

    getBulkSelectedRows() {
        const rows = this.props.rows || [];
        return Object.keys(this.state.bulkChecked)
            .filter(index => this.state.bulkChecked[index] && rows[index])
            .map(index => rows[index]);
    }

    onTableViewChange() {
        const checkRow = this.effectiveCheckRow();
        if (checkRow) {
            checkRow(undefined, undefined);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.deleteRows && !this.props.checkRow && prevProps.rows !== this.props.rows &&
            (prevProps.rows || []).length !== (this.props.rows || []).length &&
            Object.keys(this.state.bulkChecked).length > 0) {
            // The list changed (rows were deleted): the old selection no longer points at the same rows.
            this.setState({ bulkChecked: {} });
        }

        this.fitHeight();
    }

    getColumns() {
        let {
            headers,
            editRow,
            deleteRow,
            selectRow,
            archiveRow,
            copyRow,
            editTable = undefined,
            buttonsWidth = 0,
            loggedIn,
            employees,
            customActionColumn = undefined,
            currentConfig,
        } = this.props;

        let fieldsMap = getFields(currentConfig, true);
        if (this.props.customFieldsMap) {
            fieldsMap = {...fieldsMap, ...this.props.customFieldsMap};
        }

        let columns = headers.map((header, headerIndex) => {
            let name = `${header.table}.${header.name}`;
            let filterMethod = undefined;
            if (fieldsMap[name] && fieldsMap[name].type == 'Contact') {
                filterMethod = (filter, row) => {
                    let text = row[filter.id] || '';
                    if (text === '{}') {
                        text = "";
                    } else if (maybeSerializedJson(text)) {
                        try {
                            let obj = JSON.parse(text);
                            if (obj['$Label$']) {
                                text = obj['$Label$'];
                            }
                        } catch (e) {}
                    }

                    return text.toLowerCase().indexOf(filter.value.toLowerCase() ) !== -1;
                };

            } else {
                filterMethod = (filter, row) => {
                    const text = row[filter.id] === undefined ?  '' : row[filter.id] + '';
                    if (_.isString(filter.value)) {
                        return text.toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
                    } else if (_.isArray(filter.value) && filter.value.length > 0) {
                        let result = false;
                        filter.value.map(v => v['label']).forEach(v => {
                            result = result || text.toLowerCase().indexOf(v.toLowerCase()) !== -1;
                        });

                        return result;
                    }

                    return true;
                }
            }

            let sortMethod = undefined;
            if (fieldsMap[name]) {
                if (name == 'intake.CreatedDate' ||
                    name == 'client.CreatedDate' || 
                    fieldsMap[name].type == 'DateInput' || 
                    fieldsMap[name].type == 'DateTimeInput') {
                    sortMethod = dateSort;
                } else if (fieldsMap[name].type == 'Cash') {
                    sortMethod = integerSort;
                } else if (fieldsMap[name].type == 'DiskSize') {
                    sortMethod = floatSort;
                }
            }

            let cellRender;
            if (typeof header.cellRender === 'function') {
                cellRender = header.cellRender;
            } else if (name == 'intake.AssignedTo') {
                cellRender = row => <TextDataCell value={getAssignedToFullName(row.value, loggedIn, employees)} row={row}/>;
            } else {
                cellRender = row => <TextDataCell value={row.value} row={row}/>;
            }

            return {
                id: headerIndex,
                accessor: `${header.table}.${header.name}`,
                filterMethod,
                ...header,
                Header: header['label'],
                width: header.width,
                sortMethod,
                Cell: cellRender,
            }
        });

        let buttonsActive = 0;
        let buttons = [editRow, archiveRow, deleteRow, selectRow, copyRow];
        for (let i = 0; i < buttons.length; i++) {
            if (buttons[i]) {
                buttonsActive += 1;
            }
        }

        const checkRow = this.effectiveCheckRow();
        const checkedRowsProp = this.effectiveCheckedRows();
        let allCheckedState = true;
        const checkedRows = {...checkedRowsProp};
        if (checkRow) {
            let allChecked = true;
            for (let i = 0; i < this.visibleRows.length; i++) {
                if (!checkedRows[this.visibleRows[i]]) {
                    allChecked = false;
                    break;
                }
            }

            if (allChecked && this.visibleRows.length > 0) {
                allCheckedState = false;
            }
        }

        let editTableHeader = '';
        if (editTable) {
            if (buttonsActive < 1) {
                buttonsActive = 1;
            }

            editTableHeader = (
                <Button onClick={editTable}
                        icon="cog"
                        bsStyle="link"
                        style={{marginLeft: -20, height: 15, marginTop: -20}}
                        tooltip="Modify visible columns" />
            );
        }

        if (customActionColumn) {
            columns.unshift(customActionColumn);
            if (deleteRow) {
                // The custom action column only draws an icon: give delete its own trash column.
                columns.push({
                    Header: '',
                    maxWidth: 72,
                    width: 72,
                    minWidth: 72,
                    sortable: false,
                    resizable: false,
                    filterable: false,
                    accessor: 'delete',
                    className: 'ct-trash-cell',
                    headerClassName: 'ct-trash-cell',
                    Cell: row => (
                        <Button onClick={(evt) => { evt.preventDefault(); evt.stopPropagation(); deleteRow(row.index, row.original); }}
                                icon="trash"
                                bsStyle="link"
                                tooltip="Delete"
                                className="ct-trash" />
                    ),
                });
            }
        } else if (buttonsActive > 0 || editTable) {
            if (!buttonsWidth) {
                buttonsWidth = buttonsActive * 50;
            }

            columns.unshift({
                Header: editTableHeader,
                maxWidth: buttonsWidth,
                width: buttonsWidth,
                minWidth: buttonsWidth,
                sortable: false,
                resizable: false,
                filterable: false,
                accessor: 'action',
                Cell: (row) => {return (
                       <ActionCell editRow={this.props.editRow}
                                   editLabel={this.props.editLabel}
                                   editBsStyle={this.props.editBsStyle}
                                   archiveRow={this.props.archiveRow}
                                   deleteRow={this.props.deleteRow}
                                   deleteLabel={this.props.deleteLabel}
                                   deleteBsStyle={this.props.deleteBsStyle}
                                   selectRow={this.props.selectRow}
                                   selectLabel={this.props.selectLabel}
                                   selectBsStyle={this.props.selectBsStyle}
                                   downloadRow={this.props.downloadRow}
                                   downloadLabel={this.props.downloadLabel}
                                   downloadBsStyle={this.props.downloadBsStyle}
                                   copyRow={this.props.copyRow}
                                   buttonsSpace={this.props.buttonsSpace}
                                   row={row.original}
                                   index={row.index}/>)
                },
            });
        }

        if (checkRow) {
            const checkWidth = this.props.renderRowActions ? 65 : 30;
            columns.unshift({
                Header: (
                    <CheckBox 
                        field={{
                            name: 'HeaderCheckBox'
                        }}
                        plainInput
                        checked={allCheckedState}
                        onChange={(evt) => {
                            if (allCheckedState) {
                                const checkIndexes = [];
                                for (let i = 0; i < this.visibleRows.length; i++) {
                                    if (!checkedRows[this.visibleRows[i]]) {
                                        checkIndexes.push(this.visibleRows[i]);
                                    }
                                }

                                checkRow(undefined, checkIndexes);
                            } else {
                                checkRow(undefined, undefined);
                            }
                        }}
                        style={{paddingTop: 0, marginBottom: 0, paddingBottom: 0}}
                    />
                ),
                maxWidth: checkWidth,
                width: checkWidth,
                minWidth: checkWidth,
                sortable: false,
                resizable: false,
                filterable: false,
                accessor: 'check',
                style: this.props.renderRowActions
                    ? { display: 'flex', alignItems: 'center', justifyContent: 'center' }
                    : undefined,
                Cell: row =>
                        <ActionCell
                            checkRow={checkRow}
                            checkedRows={checkedRowsProp}
                            renderRowActions={this.props.renderRowActions}
                            row={row.original}
                            index={row.index}
                        />
            });
        }

        return columns;
    }

    render() {
        let {
            rows,
            copyRow,
            copyRowContainer = undefined,
            loading,
            width,
            defaultPageSize,
            filterable = true,
            sortable = true,
            serverPaging = undefined,
        } = this.props;

        if (!this.clipboard && copyRowContainer && copyRow) {
            this.clipboard = new ClipboardJS('.copyBtn', {
                container: copyRowContainer,
            });
        }

        const size = findBootstrapEnvironment();
        if (size === 'xs') {
            defaultPageSize = 7;
        }

        const columns = this.getColumns();

        // Server-side paging/sorting: `rows` is just the current page, the parent loads the others.
        let serverProps = {};
        if (serverPaging) {
            serverProps = {
                manual: true,
                multiSort: false,
                // Infinite scroll: every loaded row is shown on one page and the next page is
                // requested when the list is scrolled near its end.
                pages: 1,
                page: 0,
                pageSize: Math.max(rows ? rows.length : 0, 1),
                sorted: serverPaging.sorted,
                onSortedChange: (newSorted) => {
                    const sorted = this.nextSort(serverPaging.sorted, newSorted);
                    this.onTableViewChange();
                    serverPaging.onChange({
                        sort: sorted.length > 0 ? this.getSortAccessor(sorted[0].id) : undefined,
                        desc: sorted.length > 0 ? sorted[0].desc : false,
                        page: 0,
                    });
                },
            };
        }

        const bulkSelected = this.props.deleteRows ? this.getBulkSelectedRows() : [];
        return (
            <React.Fragment>
            <ReactTable
                PaginationComponent={ReactTablePagination}
                ref={this.tableRef}
                data={rows}
                className="-highlight -striped ct-scroll"
                showPagination={false}
                pageSize={Math.max(Math.min(this.state.visibleCount, rows ? rows.length : 0), 1)}
                getTbodyProps={() => ({ onScroll: this.onScroll })}
                defaultFilterMethod={(filter, row) =>
                    row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase() ) !== -1
                }
                minRows={0}
                sortable={sortable}
                multiSort={sortable}
                resizable
                defaultResized={this.defaultResized || (this.defaultResized = this.loadResized() || [])}
                onPageChange={this.onTableViewChange}
                onPageSizeChange={this.onTableViewChange}
                sorted={this.state.sorted}
                onSortedChange={(sorted) => {
                    this.setState({ sorted: this.nextSort(this.state.sorted, sorted) });
                    this.onTableViewChange();
                }}
                onFilteredChange={this.onTableViewChange}
                onResizedChange={this.onColumnResized}
                onExpandedChange={this.onTableViewChange}
                filterable={filterable}
                NoDataComponent={CustomNoDataComponent}
                loading={loading && !(serverPaging && rows && rows.length > 0)}
                columns={columns}
                style={{
                    width: width - 30,
                }}
                {...serverProps}
                getTrProps={(state, rowInfo, column) => {
                    return {
                        style: { cursor: this.props.editRow || this.props.downloadRow || this.props.selectRow ? 'pointer' : '' }
                    };
                }}
                getTheadThProps={(state, rowInfo, column) => {
                    return {
                        style: {
                            paddingTop: 20,
                            paddingBottom: 5,
                            textAlign: 'left',
                        }
                    }
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    if (this.props.getTdProps) {
                        const result = this.props.getTdProps(state, rowInfo, column, instance, this.props);
                        if (result) {
                            return result;
                        }
                    }

                    return {
                        onClick: (e, handleOriginal) => {
                            if (!rowInfo) {
                                return;
                            }

                            if (column.id === 'action' || column.id === 'check') {
                                return;
                            }

                            if (this.props.editRow) {
                                this.props.editRow(rowInfo.index, rowInfo.original);
                            } else if (this.props.selectRow) {
                                this.props.selectRow(rowInfo.index, rowInfo.original);
                            } else if (this.props.downloadRow) {
                                this.props.downloadRow(rowInfo.index, rowInfo.original);
                            }
                        },
                    };
                  }}
            >
            {(state, makeTable, instance) => {
                this.visibleRows = state.sortedData.map(d => d._index);
                return makeTable();
            }}
            </ReactTable>
            {bulkSelected.length > 0 && (
                <div className="ct-bulkbar" role="status">
                    <span>{bulkSelected.length} selected</span>
                    <Button onClick={() => this.setState({ bulkConfirmOpen: true })}
                            icon="trash"
                            bsStyle="default"
                            label="Delete selected" />
                    <Button onClick={() => this.setState({ bulkChecked: {} })}
                            bsStyle="link"
                            label="Clear" />
                </div>
            )}
            {this.props.deleteRows && (
                <ConfirmDialog
                    title="Delete?"
                    text={`Do you really want to delete ${bulkSelected.length} selected item${bulkSelected.length === 1 ? '' : 's'}?`}
                    warning
                    cancel={() => this.setState({ bulkConfirmOpen: false })}
                    confirm={() => {
                        this.setState({ bulkConfirmOpen: false, bulkChecked: {} });
                        this.props.deleteRows(bulkSelected);
                    }}
                    open={!!this.state.bulkConfirmOpen && bulkSelected.length > 0} />
            )}
            {serverPaging && serverPaging.loadingMore && (
                <div className="ct-loading-more" role="status"><span className="ct-spinner" />Loading more ...</div>
            )}
            </React.Fragment>
        );
    }
}

class _Table extends PureComponent {
    render() {
        return (
            <ContainerDimensions>
                <CustomTable {...this.props} />
            </ContainerDimensions>);
    }
}

CustomTable.propTypes = {
    headers: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    onColumnResized: PropTypes.func,
    containerWidth: PropTypes.number,
    containerHeight: PropTypes.number,
    selectRow: PropTypes.func,
    selectLabel: PropTypes.string,
    selectBsStyle: PropTypes.string,
    checkRow: PropTypes.func,
    checkedRows: PropTypes.object,
    deleteRows: PropTypes.func,
    editRow: PropTypes.func,
    editLabel: PropTypes.string,
    editBsStyle: PropTypes.string,
    buttonsWidth: PropTypes.int,
    archiveRow: PropTypes.func,
    deleteRow: PropTypes.func,
    deleteLabel: PropTypes.string,
    deleteBsStyle: PropTypes.string,
    downloadRow: PropTypes.func,
    downloadLabel: PropTypes.string,
    downloadBsStyle: PropTypes.string,
    editTable: PropTypes.func,
    width: PropTypes.int,
    customFieldsMap: PropTypes.object,
    getRef: PropTypes.func,
    customActionColumn: PropTypes.object,
    renderRowActions: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        currentConfig: state.user.config,
        loggedIn: state.user.loggedIn,
        employees: state.user.employees,
    };
};

export default connect(mapStateToProps)(_Table);
